import { render } from "./TaxRates.vue?vue&type=template&id=15aac267"
import script from "./TaxRates.vue?vue&type=script&lang=js"
export * from "./TaxRates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__